import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import _ from 'lodash';
import { AppConstants } from '../../common/app-constants';
import { PartnerWorkshopApi } from '../../services/partner-workshop.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-partner-document-upload',
  templateUrl: './partner-document-upload.component.html',
  styleUrls: ['./partner-document-upload.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PartnerDocumentUploadComponent implements OnInit {
  @ViewChild('AccessListFileUpload', { static: false })
  accessListFileUpload!: ElementRef;
  @Input()
  workshopType!: PartnerDocumentUploadComponent;
  @Output() uploadCompletedEvent = new EventEmitter<any>();

  notificationMessage: any[] = [];
  uploadDocumentForm!: FormGroup;
  selectedWorkshopType!: number;
  hasError = false;
  hasWarning = false;
  validationSucces = false;
  loading = false;
  selectedEngagementType = '';
  @Input() isHybridWithCustomerList!: boolean;
  duplicateMpnIDstoShow!: string;
  paidFacilitatorIDstoShow!: string;
  duplicateTenantIDstoShow!: string;
  invalidTenantIDstoShow!: string;
  vOrgIDstoShow!: string;
  invalidMpnIDstoShow!: string;
  invalidTPIDstoShow!: string;
  userType!: string;
  isDialogOpen!: boolean;
  fileToUpload!: File | null;

  constructor(
    private formBuilder: FormBuilder,
    private partnerworkshopservice: PartnerWorkshopApi
  ) {}

  ngOnInit(): void {
    this.onFromGroup();
  }

  onFromGroup(): void {
    this.uploadDocumentForm = this.formBuilder.group({
      userType: ['']
    });
  }

  showDialog(): void {
    this.isDialogOpen = true;
  }

  closeDialog(): void {
    this.isDialogOpen = false;
    this.hasError = false;
    this.hasWarning = false;
    this.validationSucces = false;

    this.uploadDocumentForm = this.formBuilder.group({
      userType: ['']
    });

    this.duplicateMpnIDstoShow = '';
    this.vOrgIDstoShow = '';
    this.invalidMpnIDstoShow = '';
    this.invalidTPIDstoShow = '';
    this.duplicateTenantIDstoShow = '';
    this.invalidTenantIDstoShow = '';
    this.userType = '';
    this.fileToUpload = null;
    this.paidFacilitatorIDstoShow = '';
  }

  openFilePicker(fileInput: HTMLInputElement): void {
    this.accessListFileUpload.nativeElement.value = null;
    fileInput.click();
  }

  validateAccessListExcelFile(event): void {
    const isWorkshopTypeValid = _.isNumber(this.selectedWorkshopType);
    const hasFile =
      event.target &&
      !_.isEmpty(event.target.files) &&
      this.validateFileType(event.target.files[0].name);
    const canUpload = isWorkshopTypeValid && hasFile;
    if (canUpload) {
      this.fileToUpload = event.target.files[0];
      const formData = new FormData();

      if (this.fileToUpload) {
        formData.append('file', this.fileToUpload, this.fileToUpload.name);
      }

      this.userType = this.uploadDocumentForm.controls['userType'].value;
      this.loading = true;

      if (this.uploadDocumentForm.controls['userType'].value === 'Partner') {
        this.partnerworkshopservice
          .validatePartnerWorkshopPartnerList(
            this.selectedWorkshopType,
            formData
          )
          .subscribe(response => {
            this.loading = false;
            this.hasError = response.hasError;
            this.hasWarning = response.hasWarning;

            let message = AppConstants.validationSuccessMsg;
            if (this.hasWarning) {
              message = AppConstants.uploadWarningMsg;
              this.showNotificationMessage(message, 'warn');
            } else if (this.hasError) {
              message = AppConstants.uploadErrorMsg;
              this.showNotificationMessage(message, 'error');
            } else {
              this.validationSucces = true;
              this.showNotificationMessage(message);
            }

            this.duplicateMpnIDstoShow = this.generateStringOfIds(
              response.duplicateMpnIdList
            );
            this.vOrgIDstoShow = this.generateStringOfIds(response.vOrgIdList);
            this.invalidMpnIDstoShow = this.generateStringOfIds(
              response.invalidMpnIdList
            );
            this.paidFacilitatorIDstoShow = this.generateStringOfIds(
              response.paidFacilitatorMpnIdList
            );
          });
      } else {
        this.partnerworkshopservice
          .validatePrivateWorkshopCustomerList(
            this.selectedWorkshopType,
            formData
          )
          .subscribe(
            response => {
              this.loading = false;
              this.showNotificationMessage(JSON.stringify(response, null, 4));
              this.hasError = response.hasError;
              this.hasWarning = response.hasWarning;
              let message = AppConstants.uploadSuccessMsg;

              if (this.hasWarning) {
                message = AppConstants.uploadWarningMsg;
                this.showNotificationMessage(message, 'warn');
              } else if (this.hasError) {
                message = AppConstants.customerUploadErrorMsg;
                this.showNotificationMessage(message, 'error');
              } else {
                this.validationSucces = true;
                this.showNotificationMessage(message);
              }
              this.duplicateTenantIDstoShow = this.generateStringOfIds(
                response.tenantIdListImport.duplicateTenantIdList
              );

              this.invalidTenantIDstoShow = this.generateStringOfIds(
                response.tenantIdListImport.invalidTenantIdList
              );

              this.invalidTPIDstoShow = this.generateStringOfIds(
                response.tpIdListImport.invalidTPIdList
              );
            },
            () => {
              this.loading = false;
            }
          );
      }
    }
  }

  validateFileType(fileName: string): boolean {
    const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
    const supportedExtensions = ['xlsm', 'xlsx', 'xls'];
    const index = supportedExtensions.indexOf(ext);
    return index > -1;
  }

  isPartnerDocumentTypeSelected(): boolean {
    if (this.uploadDocumentForm.controls['userType'].value !== '') {
      return true;
    }
    return false;
  }
  isDocumentTypeSelected(): boolean {
    if (this.uploadDocumentForm.controls['userType'].value !== '') {
      return true;
    }
    return false;
  }

  showNotificationMessage(message: string, severity = 'success'): void {
    this.notificationMessage = [];
    this.notificationMessage.push({
      severity: severity,
      detail: message,
      closable: false,
      sticky: true
    } as any);
  }

  generateStringOfIds(idList: string[]): string {
    let idStringToDisplay = '';
    if (idList != null && idList.length > 0) {
      const distinctIdList = _.union(idList);
      distinctIdList.forEach(item => {
        idStringToDisplay =
          idStringToDisplay == null
            ? ' ' + item + ','
            : idStringToDisplay + ' ' + item + ',';
      });
      idStringToDisplay = idStringToDisplay.slice(0, -1);
    }
    return idStringToDisplay;
  }

  uploadAccessListExcelFile(): void {
    const formData = new FormData();
    if (this.fileToUpload) {
      formData.append('file', this.fileToUpload, this.fileToUpload.name);
    }

    this.userType = this.uploadDocumentForm.controls['userType'].value;
    this.loading = true;
    if (this.userType === 'Partner') {
      this.partnerworkshopservice
        .uploadPartnerWorkshopList(this.selectedWorkshopType, formData)
        .subscribe(
          () => {
            this.loading = false;
            this.uploadCompletedEvent.emit(true);
            this.closeDialog();
          },
          error => {
            this.loading = false;
            this.showNotificationMessage(JSON.stringify(error, null, 4));
          }
        );
    }
    if (this.userType === 'Customer') {
      this.partnerworkshopservice
        .UploadCustomerList(this.selectedWorkshopType, formData)
        .subscribe(
          () => {
            this.loading = false;
            this.uploadCompletedEvent.emit(true);
            this.closeDialog();
          },
          error => {
            this.loading = false;
            this.showNotificationMessage(JSON.stringify(error, null, 4));
          }
        );
    }
  }
}
